// import Vue from 'vue'
import { eventService } from '@/services';

import moment from 'moment-timezone';
// import router from '@/router'

const state = {
  categories: [],
  comments: [],
  htagsStatus: false,
  htags: [],
  partners: [],
  postedEvent: null,
  postedTickets: null,
  myEvents: [],
  myProfileEvents: [],
  exploreEvents: [],
  recommendedEvents: [],
  likedEvents: [],
  lovedEvents: [],
  attendingEvents: [],
  myEventsState: '',
  categoriesStatus: false,
  partnersStatus: false,
  postedEventStatus: false,
  posteventerror: null,
  eventStatus: false,
  eventCommentsStatus: false,
  postTicketsStatus: false,
  myEventsStatus: false,
  myprofileEventsStatus: false,
  exploreEventsStatus: false,
  recommendedEventsStatus: false,
  likedEventsStatus: false,
  lovedEventsStatus: false,
  attendingEventsStatus: false,
  postingEventStatus: false,
  event: {},
  pinPoint: {},
  currentActivityBookmark: 'activity',
  ticketBookmark: 'Event',
  currentSelectedFilters: {
    location: {
      lat: 40.3417249,
      lng: -84.9124694,
      place: '',
      address: '',
      city: '',
      country: '',
    },
    radius: -1,
    age: [0, 100],
    price: [0, 200],
    today: false,
    sort: {
      id: 1,
      value: 'DATE',
      name: 'Date',
    },
    date: {
      id: 4,
      value: 'month',
      name: 'This Month',
    },
    fromDate: null,
    toDate: null,
    category: 'ALL',
    fromDate: moment().format('YYYY-MM-DD'),
    toDate: moment().format('YYYY-MM-DD'),
  },
  currentView: 'list',
  bookmark: 'like',
  services: [],
  exploreTotalPages: 1,
  exploreCurrentPage: 1,
  sidenav: false,
  startSearch: -1,
  unamplifyEventStatus: '',
  unamplifiedEvent: null,
};

const debounce = (func, timeout = 3000) => {
  let timer;
  clearTimeout(timer);
  timer = setTimeout(() => {
    func();
  }, timeout);
};

const actions = {
  getLocations({ dispatch, commit, state }, params) {
    return eventService.getLocations(params).then(
      (event) => {
        state.pinPoint = event;
        return event;
      },
      (error) => {
        dispatch('alert/error', error, { root: true });
        return error;
      }
    );
  },
  gethashtags({ dispatch, commit }) {
    commit('hastagsRequest');

    eventService.gethashtags().then(
      (categories) => {
        commit('hastagsRequestSuccess', categories);
      },
      (error) => {
        commit('hastagsRequestFailed', error);
      }
    );
  },
  getCategories({ dispatch, commit }) {
    commit('categoriesRequest');

    debounce(() => {
      eventService.getCategories().then(
        (categories) => {
          commit('categoriesSuccess', categories);
        },
        (error) => {
          commit('categoriesFailed', error);
          dispatch('alert/error', error, { root: true });
        }
      );
    }, 2000);
  },
  getPartners({ dispatch, commit }) {
    commit('partnersRequest');

    eventService.getPartners().then(
      (partners) => {
        commit('partnersSuccess', partners);
      },
      (error) => {
        commit('partnersFailed', error);
        dispatch('alert/error', error, { root: true });
      }
    );
  },
  getServices({ dispatch, commit }) {
    eventService.getServices().then(
      (partners) => {
        commit('servicesSuccess', partners);
      },
      (error) => {
        commit('servicesFailed', error);
        dispatch('alert/error', error, { root: true });
      }
    );
  },
  postFeedback({ dispatch, commit }, data) {
    return eventService.postFeedback(data);
  },
  postEvent({ dispatch, commit }, eventData) {
    commit('postEventRequest');

    eventService.postEvent(eventData).then(
      (postedEvent) => {
        commit('postEventSuccess', postedEvent);
        dispatch(
          'alert/success',
          'Event created successfully. Adding tickets...',
          { root: true }
        );
      },
      (error) => {
        commit('postEventFailed', error);
        dispatch('alert/error', error, { root: true });
      }
    );
  },
  updateEvent({ dispatch, commit }, eventData) {
    commit('postEventRequest');

    eventService.updateEvent(eventData).then(
      (postedEvent) => {
        commit('postEventSuccess', postedEvent);
        dispatch(
          'alert/success',
          'Event updated successfully. Adding tickets...',
          { root: true }
        );
      },
      (error) => {
        commit('postEventFailed', error);
        dispatch('alert/error', error, { root: true });
      }
    );
  },
  unamplifyEvent({ dispatch, commit }, eventData) {
    commit('unamplifyEventRequest');

    eventService.unamplifyEvent(eventData).then(
      (postedEvent) => {
        commit('unamplifyEventSuccess', postedEvent);
        dispatch(
          'alert/success',
          'Event updated successfully. Adding tickets...',
          { root: true }
        );
      },
      (error) => {
        commit('unamplifyEventFailed', error);
        dispatch('alert/error', error, { root: true });
      }
    );
  },
  updateTickets({ dispatch, commit }, ticketsData) {
    return eventService.updateTickets(ticketsData);
  },
  postTickets({ dispatch, commit }, ticketsData) {
    commit('postTicketsRequest');

    eventService.postTickets(ticketsData).then(
      (postedTickets) => {
        commit('postTicketsSuccess', postedTickets);
        dispatch('alert/success', 'Tickets added successfully.', {
          root: true,
        });
      },
      (error) => {
        commit('postTicketsFailed', error);
        dispatch('alert/error', error, { root: true });
      }
    );
  },
  getMyPaginatedEvents({ dispatch, commit }, params) {
    return eventService.getMyPaginatedEvents(params);
  },
  getMyPaginatedLiked({ dispatch, commit }, params) {
    return eventService.getMyPaginatedLiked(params);
  },
  getMyPaginatedAttending({ dispatch, commit }, params) {
    return eventService.getMyPaginatedAttending(params);
  },
  getMyPaginatedLoved({ dispatch, commit }, params) {
    return eventService.getMyPaginatedLoved(params);
  },
  getMyPaginatednotifciation({ dispatch, commit }, params) {
    return eventService.getMyPaginatednotifciation(params);
  },
  getMyPaginatedActivity({ dispatch, commit }, params) {
    return eventService.getMyPaginatedActivity(params);
  },
  getMyProfileEvents({ dispatch, commit }, params) {
    commit('myprofileEventsState', { status: 'pending', myEvents: [] });

    eventService.getMyProfileEvents(params).then(
      (myEvents) => {
        commit('myprofileEventsState', {
          status: 'success',
          myEvents: myEvents,
        });
      },
      (error) => {
        commit('myprofileEventsState', { status: 'success', myEvents: [] });
        dispatch('alert/error', error, { root: true });
      }
    );
  },
  getMyEvents({ dispatch, commit }, params) {
    commit('myEventsState', { status: 'pending', myEvents: [] });

    eventService.getMyEvents(params).then(
      (myEvents) => {
        commit('myEventsState', { status: 'success', myEvents: myEvents });
      },
      (error) => {
        commit('myEventsState', { status: 'success', myEvents: [] });
        dispatch('alert/error', error, { root: true });
      }
    );
  },
  deleteEvent({ dispatch, commit, state }, params) {
    return eventService.deleteEvent(params);
  },
  getExploreEvents({ dispatch, commit, state }, params) {
    commit('exploreEventsState', {
      status: 'pending',
      exploreEvents: state.exploreEvents,
    });

    eventService.getExploreEvents(params).then(
      (exploreEvents) => {
        commit('exploreEventsState', {
          status: 'success',
          exploreEvents: exploreEvents.data,
          totalPages: exploreEvents.pagination.totalPages,
          currentPage: exploreEvents.pagination.currentPage,
        });
      },
      (error) => {
        commit('exploreEventsState', { status: 'success', exploreEvents: [] });
        dispatch('alert/error', error, { root: true });
      }
    );
  },
  getRecommendedEvents({ dispatch, commit }, userId, categoryId) {
    commit('recommendedEventsState', {
      status: 'pending',
      recommendedEvents: [],
    });

    eventService.getExploreEvents({ userId, categoryId }).then(
      (recommendedEvents) => {
        commit('recommendedEventsState', {
          status: 'success',
          recommendedEvents: recommendedEvents,
        });
      },
      (error) => {
        commit('recommendedEventsState', {
          status: 'success',
          recommendedEvents: [],
        });
        dispatch('alert/error', error, { root: true });
      }
    );
  },
  getLikedEvents({ dispatch, commit }, userId) {
    commit('likedEventsState', { status: 'pending', likedEvents: [] });

    eventService.getLikedEvents(userId).then(
      (likedEvents) => {
        commit('likedEventsState', {
          status: 'success',
          likedEvents: likedEvents,
        });
      },
      (error) => {
        commit('likedEventsState', { status: 'success', likedEvents: [] });
        dispatch('alert/error', error, { root: true });
      }
    );
  },
  getLovedEvents({ dispatch, commit }, userId) {
    commit('lovedEventsState', { status: 'pending', lovedEvents: [] });

    eventService.getLovedEvents(userId).then(
      (lovedEvents) => {
        commit('lovedEventsState', {
          status: 'success',
          lovedEvents: lovedEvents,
        });
      },
      (error) => {
        commit('lovedEventsState', { status: 'success', lovedEvents: [] });
        dispatch('alert/error', error, { root: true });
      }
    );
  },
  getAttendingEvents({ dispatch, commit }, userId) {
    commit('attendingEventsState', { status: 'pending', attendingEvents: [] });

    eventService.getAttendingEvents(userId).then(
      (attendingEvents) => {
        commit('attendingEventsState', {
          status: 'success',
          attendingEvents: attendingEvents,
        });
      },
      (error) => {
        commit('attendingEventsState', {
          status: 'success',
          attendingEvents: [],
        });
        dispatch('alert/error', error, { root: true });
      }
    );
  },

  seteventSuccess({ state }, res) {
    state.myEvents = res;
  },
  getEventDetails({ dispatch, commit }, id) {
    commit('eventRequest');

    eventService.getEventDetails(id).then(
      (event) => {
        this.event = event[0];
        commit('eventSuccess', event[0]);
      },
      (error) => {
        commit('eventFailed', error);
        dispatch('alert/error', error, { root: true });
      }
    );
  },

  getEventComments({ dispatch, commit }, id) {
    commit('eventCommentsRequest');

    eventService.getComments(id).then(
      (comments) => {
        this.comments = comments;
        commit('eventCommentsSuccess', comments);
      },
      (error) => {
        commit('eventCommentsFailed', error);
        dispatch('alert/error', error, { root: true });
      }
    );
  },
  postUserComment({ dispatch, commit }, params) {
    commit('commentStatus');

    eventService.postComment(params).then(
      (comments) => {
        commit('eventCommentsSuccess', comments);
      },
      (error) => {
        commit('eventCommentsFailed', error);
        dispatch('alert/error', error, { root: true });
      }
    );
  },
  getLocations({ dispatch, commit, state }, params) {
    return eventService.getLocations(params).then(
      (event) => {
        state.pinPoint = event;
        return event;
      },
      (error) => {
        dispatch('alert/error', error, { root: true });
        return error;
      }
    );
  },

  likEvent({ dispatch, commit }, params) {
    eventService.likeEvent(params).then(
      (event) => {
        commit('likeEventSuccess', event);
      },
      (error) => {
        commit('likeEventFailure', error);
        dispatch('alert/error', error, { root: true });
      }
    );
  },
  loveEvent({ dispatch, commit }, params) {
    eventService.loveEvent(params).then(
      (event) => {
        commit('loveEventSuccess', event);
      },
      (error) => {
        commit('loveEventFailed', error);
        dispatch('alert/error', error, { root: true });
      }
    );
  },
  attendEvent({ dispatch, commit }, params) {
    return eventService.attendEvent(params).then(
      (event) => {
        commit('attendEventSuccess', event);
        return event;
      },
      (error) => {
        commit('attendEventFailed', error);
        dispatch('alert/error', error, { root: true });
        return event;
      }
    );
  },
  unLikeEvent({ dispatch, commit }, params) {
    return eventService.unLikeEvent(params).then(
      (event) => {
        commit('unLikeEventSuccess', event);
        return event;
      },
      (error) => {
        commit('unLikeEventsFailed', error);
        dispatch('alert/error', error, { root: true });
        return error;
      }
    );
  },
  unLoveEvent({ dispatch, commit }, params) {
    return eventService.unLoveEvent(params).then(
      (event) => {
        commit('unLoveEventSuccess', event);
        return event;
      },
      (error) => {
        commit('unLoveEventFailed', error);
        dispatch('alert/error', error, { root: true });
        return error;
      }
    );
  },
  unAttendEvent({ dispatch, commit }, params) {
    return eventService.unAttendEvent(params).then(
      (event) => {
        commit('unAttendEventSuccess', event);
        return event;
      },
      (error) => {
        commit('unAttendEventFailed', error);
        dispatch('alert/error', error, { root: true });
        return error;
      }
    );
  },
};

const mutations = {
  categoriesRequest(state) {
    state.categoriesStatus = false;
  },
  hastagsRequest() {
    state.htagsStatus = true;
    state.htags = [];
  },
  hastagsRequestSuccess(state, tags) {
    state.htags = tags;
    state.htagsStatus = false;
  },
  hastagsRequestFailed() {
    state.htags = [];
    state.htagsStatus = false;
  },
  eventRequest(state) {
    state.eventStatus = true;
    state.event = {};
  },
  eventSuccess(state, event) {
    state.event = event;
    state.eventStatus = false;
  },
  eventFailed(state) {
    state.eventStatus = false;
    state.event = {};
  },
  eventCommentsRequest(state) {
    state.eventCommentsStatus = false;
    state.comments = [];
  },
  eventCommentsSuccess(state, comments) {
    state.eventCommentsStatus = true;
    state.comments = comments;
  },
  eventCommentsFailed(state) {
    state.eventCommentsStatus = false;
    state.comments = [];
  },
  categoriesSuccess(state, categories) {
    state.categoriesStatus = true;
    state.categories = categories;
  },
  categoriesFailed(state) {
    state.categoriesStatus = false;
  },
  partnersRequest(state) {
    state.partnersStatus = false;
    state.partners = [];
  },
  partnersSuccess(state, partners) {
    state.partnersStatus = true;
    state.partners = partners;
  },
  partnersFailed(state) {
    state.partnersStatus = false;
    state.partners = [];
  },
  postEventRequest(state) {
    state.postedEventStatus = false;
    state.postedEvent = null;
    state.myEventsState = 'pending';
  },
  postEventSuccess(state, postedEvent) {
    state.postedEventStatus = true;
    state.postedEvent = postedEvent;
    state.myEventsState = 'success';
  },
  servicesSuccess(state, values) {
    state.services = values;
  },
  servicesFailed(state) {
    state.services = [];
  },
  postEventFailed(state, err) {
    state.postedEventStatus = false;
    state.postedEvent = null;
    state.myEventsState = 'error';
    state.posteventerror = err;
  },
  postTicketsRequest(state) {
    state.postTicketsStatus = false;
    state.postedTickets = null;
  },
  unamplifyEventRequest(state) {
    state.unamplifyEventStatus = 'pending';
  },
  unamplifyEventSuccess(state, data) {
    state.unamplifyEventStatus = 'success';
    state.unamplifiedEvent = data;
    state.myEvents = state.myEvents.map((eve) => {
      if (eve.eventCode === data.eventCode) {
        return data;
      }

      return eve;
    });
  },
  unamplifyEventFailed(state) {
    state.unamplifyEventStatus = 'failed';
    state.unamplifiedEvent = null;
  },
  postTicketsSuccess(state, postedTickets) {
    state.postTicketsStatus = true;
    state.postedTickets = postedTickets;
  },
  postTicketsFailed(state) {
    state.postTicketsStatus = false;
    state.postedTickets = null;
  },
  myEventsState(state, status) {
    state.myEventsStatus = status.status;
    state.myEvents = status.myEvents;
  },
  myprofileEventsState(state, status) {
    state.myprofileEventsStatus = status.status;
    state.myProfileEvents = status.myEvents;
  },
  exploreEventsState(state, status) {
    state.exploreEventsStatus = status.status;
    state.exploreEvents = status.exploreEvents;
    state.exploreTotalPages = status.totalPages;
    state.exploreCurrentPage = status.currentPage;
  },
  recommendedEventsState(state, status) {
    state.recommendedEventsStatus = status.status;
    state.recommendedEvents = status.recommendedEvents;
  },
  likedEventsState(state, status) {
    state.likedEventsStatus = status.status;
    state.likedEvents = status.likedEvents;
  },
  lovedEventsState(state, status) {
    state.lovedEventsStatus = status.status;
    state.lovedEvents = status.lovedEvents;
  },
  attendingEventsState(state, status) {
    state.attendingEventsStatus = status.status;
    state.attendingEvents = status.attendingEvents;
  },
  commentStatus(state, status) {
    state.eventCommentsStatus = status;
  },
  likeEventSuccess(state, event) {
    state.exploreEvents = state.exploreEvents.map(
      (e) => event.find(({ eventCode }) => eventCode === e.eventCode) || e
    );
    // updating loved events
    state.lovedEvents = state.lovedEvents.map(
      (e) => event.find(({ eventCode }) => eventCode === e.eventCode) || e
    );
    // updating attending events
    state.attendingEvents = state.attendingEvents.map(
      (e) => event.find(({ eventCode }) => eventCode === e.eventCode) || e
    );
    // updating liked events
    state.likedEvents = state.likedEvents.map(
      (e) => event.find(({ eventCode }) => eventCode === e.eventCode) || e
    );
  },
  loveEventSuccess(state, event) {
    state.exploreEvents = state.exploreEvents.map(
      (e) => event.find(({ eventCode }) => eventCode === e.eventCode) || e
    );
    // updating loved events
    state.lovedEvents = state.lovedEvents.map(
      (e) => event.find(({ eventCode }) => eventCode === e.eventCode) || e
    );
    // updating attending events
    state.attendingEvents = state.attendingEvents.map(
      (e) => event.find(({ eventCode }) => eventCode === e.eventCode) || e
    );
    // updating liked events
    state.likedEvents = state.likedEvents.map(
      (e) => event.find(({ eventCode }) => eventCode === e.eventCode) || e
    );
  },
  attendEventSuccess(state, event) {
    state.exploreEvents = state.exploreEvents.map(
      (e) => event.find(({ eventCode }) => eventCode === e.eventCode) || e
    );
    // updating loved events
    state.lovedEvents = state.lovedEvents.map(
      (e) => event.find(({ eventCode }) => eventCode === e.eventCode) || e
    );
    // updating attending events
    state.attendingEvents = state.attendingEvents.map(
      (e) => event.find(({ eventCode }) => eventCode === e.eventCode) || e
    );
    // updating liked events
    state.likedEvents = state.likedEvents.map(
      (e) => event.find(({ eventCode }) => eventCode === e.eventCode) || e
    );
  },
  unLikeEventSuccess(state, event) {
    state.exploreEvents = state.exploreEvents.map(
      (e) => event.find(({ eventCode }) => eventCode === e.eventCode) || e
    );
    // updating loved events
    state.lovedEvents = state.lovedEvents.map(
      (e) => event.find(({ eventCode }) => eventCode === e.eventCode) || e
    );
    // updating attending events
    state.attendingEvents = state.attendingEvents.map(
      (e) => event.find(({ eventCode }) => eventCode === e.eventCode) || e
    );
    // updating liked events
    state.likedEvents = state.likedEvents.map(
      (e) => event.find(({ eventCode }) => eventCode === e.eventCode) || e
    );
  },
  unLoveEventSuccess(state, event) {
    state.exploreEvents = state.exploreEvents.map(
      (e) => event.find(({ eventCode }) => eventCode === e.eventCode) || e
    );
    // updating loved events
    state.lovedEvents = state.lovedEvents.map(
      (e) => event.find(({ eventCode }) => eventCode === e.eventCode) || e
    );
    // updating attending events
    state.attendingEvents = state.attendingEvents.map(
      (e) => event.find(({ eventCode }) => eventCode === e.eventCode) || e
    );
    // updating liked events
    state.likedEvents = state.likedEvents.map(
      (e) => event.find(({ eventCode }) => eventCode === e.eventCode) || e
    );
  },
  unAttendEventSuccess(state, event) {
    state.exploreEvents = state.exploreEvents.map(
      (e) => event.find(({ eventCode }) => eventCode === e.eventCode) || e
    );
    // updating loved events
    state.lovedEvents = state.lovedEvents.map(
      (e) => event.find(({ eventCode }) => eventCode === e.eventCode) || e
    );
    // updating attending events
    state.attendingEvents = state.attendingEvents.map(
      (e) => event.find(({ eventCode }) => eventCode === e.eventCode) || e
    );
    // updating liked events
    state.likedEvents = state.likedEvents.map(
      (e) => event.find(({ eventCode }) => eventCode === e.eventCode) || e
    );
  },
  updateCurrentView(state, viewName) {
    state.currentView = viewName;
  },
  updateCurrentFilter(state, currentFilter) {
    state.currentSelectedFilters = currentFilter;
  },
  updatebookmarkFilter(state, val) {
    state.bookmark = val;
  },
  updateTicketOption(state, val) {
    state.ticketBookmark = val;
  },
  updatecurrentActivityBookmark(state, val) {
    state.currentActivityBookmark = val;
  },
  updateSidenav(state, val) {
    state.sidenav = val;
  },
  makeSearch(state, val) {
    state.startSearch = val;
  },
};

export const events = {
  namespaced: true,
  state,
  actions,
  mutations,
};
